import React from "react";

import { ChatContent, ChatHeader, ChatNameUpdate } from "@features/chat/mobile";
import { useRootAppStore } from "@hooks";
import { observer } from "mobx-react";

const ChatBox = observer(() => {
	const { chatViewStore } = useRootAppStore();

	if (!chatViewStore.chatDisplayName) {
		return (
			<div className="chat__card">
				<ChatNameUpdate />
			</div>
		);
	}

	return (
		<div className="chat__card">
			<ChatHeader />
			<ChatContent />
		</div>
	);
});

export default ChatBox;
